import type { AgentChatSessionDetail } from '@/frontend/pages/Dashboard/AgentChats/types'

export async function sessionFromResponse(response: Response): Promise<AgentChatSessionDetail> {
  const payload = await response.json().catch(() => ({})) as { error?: string; session?: AgentChatSessionDetail }
  if (!response.ok || !payload.session) {
    // Preserve HTTP status so callers can distinguish revoked/missing records
    // from transient transport failures without inspecting localized messages.
    throw Object.assign(new Error(payload.error || 'Não foi possível sincronizar a conversa agora.'), { status: response.status })
  }
  return payload.session
}
